import Vue from 'vue'
import Vuex from 'vuex'

// modules
import auth from './modules/auth'
import layout from './modules/layout'
import taskSheet from './modules/taskSheet'
import PieceworkModule from './modules/piecework'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nameApp: process.env.VUE_APP_NAME || '',
    titlePage: ''
  },
  getters: {
    nameApp: (state) => state.nameApp,
    titlePage: (state) => state.titlePage
  },
  mutations: {
    setTitle (state, title) {
      state.titlePage = title
    }
  },
  actions: {
    setTitlePage (context, title = '') {
      context.commit('setTitle', title)
    }
  },
  modules: {
    auth,
    layout,
    taskSheet,
    piecework: PieceworkModule
  }
})
